import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Logger } from '@utils/logger';
import { SelectAllDocs } from '@marketing/subscriptions-manage/subscription-manage.interface';
/**
 * Logger
 */
const logger = Logger.getLogger('NameCellRendererComponent');

@Component({
  selector: 'ft-name-cell-renderer',
  templateUrl: './name-cell-renderer.component.html',
  styleUrls: ['./name-cell-renderer.component.scss'],
})
export class NameCellRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public cellValue: string;

  constructor() {
    // Constructor placeholder
  }

  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  /**
   * Get Data value to display in template
   * @param params - ICellRendererParams
   */
  private getValueToDisplay(params: ICellRendererParams) {
    return params.value;
  }

  /**
   * Trigger parent parent component selectAllDocs method
   * @param $event - MouseEvent
   */
  public selectAll($event: MouseEvent) {
    $event.preventDefault();
    const selectAllDocs: SelectAllDocs = {
      dataParams: this.params.data,
    };
    this.params.context.selectAllDocs(selectAllDocs);
    logger.debug('Executed Object:', JSON.stringify(selectAllDocs));
  }
}
